import { sourceAccumulator } from '@/common/converter/utils/source-accumulator'
import { getExecuteUrl } from '@/common/utils/home/get-execute-url'
import { convertCellTopList } from '@/common/converter/convert-cell-top-list'
import { convertNote } from '@/common/converter/convert-note'
import { getCellType } from '@/common/utils/home/get-cell-type'
import { getConvertCell } from '@/common/converter/utils/get-convert-cell'
import { useCatalog } from '@/common/use/useCatalog'
const { getCatalog } = useCatalog()

/**
 * 신형 카탈로그 응답을 구형 밴드 응답으로 변환
 * @param catalog
 * @returns {Promise<{cell_toplist: {blurtarget_img: string, cta: string, bgcolor: string, pagecount: string, count: string, title_list: *[]}, gen_time: string, band: {celllist: {image: {landscape_large: {background: string, text: string}, portrait: {background: string, text: string}, landscape: {background: string, text: string}}, thumbnail: string, alt: string, event_list: {bodylist: *, url: string}[], brand_taglist: string[], force_refresh: string, title_list: *[], top_taglist}[], cell_type: (*|string)}, type: (*|string), version: (*|string)}>}
 */
export const convertBand = async (catalog = {}) => {
  const { elementList = [] } = catalog

  const { data: target } = await getCatalog(getExecuteUrl(elementList))
  const source = sourceAccumulator(elementList)
  const cellType = getCellType(elementList)
  const convertCell = getConvertCell(cellType)

  return {
    type: catalog?.type ?? '',
    gen_time: '',
    version: catalog?.version ?? '',
    cell_toplist: convertCellTopList(source, target?.topContext),
    band: {
      cell_type: cellType,
      celllist: target.contextList.map((target) => convertCell(source, target)),
    },
    note: convertNote(source, target.contextList?.[0]),
  }
}
